<template>
  <div class="image-gallery">
    <el-row>
      <el-col :span="24" :md="12" :sm="24" class="image-card">
        <img :src="image1" alt="Image 1" />
      </el-col>
      <el-card shadow="always" style="padding-top: 7px;">
        <div style="font-size: 13px;text-align: center;padding-bottom: 12px;color: red;">{{titleFonet}}</div>
        <el-form v-if="formStatus === false" :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
          <el-form-item label="请选择您的岗位:（仅一次机会）" prop="post">
            <el-radio-group :disabled="needButtonStatus" v-model="ruleForm.post" class="radio-group">
              <el-radio label=1>我是开发</el-radio>
              <el-radio label=2>我是测试</el-radio>
              <el-radio label=3>其他岗位</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="请选择您的需求:（仅一次机会）" prop="demand" style="margin-top: 20px;">
            <el-radio-group :disabled="needButtonStatus" v-model="ruleForm.demand" class="radio-group">
              <el-radio label=1>借鉴思路</el-radio>
              <el-radio label=2>学习测开</el-radio>
              <el-radio label=3>好奇看下</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button :type="needButtonType" @click="submitForm('ruleForm')" style="width: 100%;margin-top: 12px;font-size: 16px;" :disabled="needButtonStatus">{{needButtonName}}</el-button>
          </el-form-item>
        </el-form>
        <el-form v-if="formStatus === true" :model="infoForm" :rules="infoRules" ref="infoForm" label-position="top" class="infoFrom">
          <el-form-item label="请输入您的姓名" prop="name" style="margin-bottom: 0px;">
            <el-input v-model="infoForm.name" placeholder="请输入姓名，非真实姓名无效"></el-input>
          </el-form-item>
          <el-form-item label="请输入您的手机" prop="phone" style="margin-bottom: 10px;">
            <el-input v-model="infoForm.phone" placeholder="手机号将作为联系您唯一凭证" maxlength="11"></el-input>
            <el-row style="padding-top:8px;width: 100%;">
              <el-col :span="12">
                <el-form-item prop="code">
                  <el-input v-model="infoForm.code" placeholder="请输入验证码" maxlength="4"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="padding-left:10px">
                <el-form-item>
                  <el-button type="primary" style="width: 100%;font-size: 16px;" :disabled="verCodeButtonStatus" @click="getVercode()">{{verCodeButtonName}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-button type="primary" :icon="loadIcon" @click="submitInfoForm('infoForm')" style="width: 100%;margin-top: 0px;font-size: 16px;" :disabled="submitInfoFormButtonStatus">5.8元试听AI测开，不再担心被AI淘汰</el-button>
        </el-form>
      </el-card>
      <el-col :span="24" :md="12" :sm="24" class="image-card" style="padding-top: 5px;">
        <img :src="image2" alt="Image 2" />
      </el-col>
      <el-col :span="24" :md="12" :sm="24" class="image-card">
        <img :src="image3" alt="Image 3" />
      </el-col>
      <el-col :span="24" :md="12" :sm="24" class="image-card">
        <img :src="image4" alt="Image 4" />
      </el-col>
      <el-card shadow="always" style="padding-top: 7px;">
        <div style="font-size: 13px;text-align: center;padding-bottom: 12px;color: red;">{{titleFonet}}</div>
        <el-form v-if="formStatus === false" :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
          <el-form-item label="请选择您的岗位:（仅一次机会）" prop="post">
            <el-radio-group :disabled="needButtonStatus" v-model="ruleForm.post" class="radio-group">
              <el-radio label=1>我是开发</el-radio>
              <el-radio label=2>我是测试</el-radio>
              <el-radio label=3>其他岗位</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="请选择您的需求:（仅一次机会）" prop="demand" style="margin-top: 20px;">
            <el-radio-group :disabled="needButtonStatus" v-model="ruleForm.demand" class="radio-group">
              <el-radio label=1>借鉴思路</el-radio>
              <el-radio label=2>学习测开</el-radio>
              <el-radio label=3>好奇看下</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button :type="needButtonType" @click="submitForm('ruleForm')" style="width: 100%;margin-top: 12px;font-size: 16px;" :disabled="needButtonStatus">{{needButtonName}}</el-button>
          </el-form-item>
        </el-form>
        <el-form v-if="formStatus === true" :model="infoForm" :rules="infoRules" ref="infoForm" label-position="top" class="infoFrom">
          <el-form-item label="请输入您的姓名" prop="name" style="margin-bottom: 0px;">
            <el-input v-model="infoForm.name" placeholder="请输入姓名，非真实姓名无效"></el-input>
          </el-form-item>
          <el-form-item label="请输入您的手机" prop="phone" style="margin-bottom: 10px;">
            <el-input v-model="infoForm.phone" placeholder="手机号将作为联系您唯一凭证" maxlength="11"></el-input>
            <el-row style="padding-top:8px;width: 100%;">
              <el-col :span="12">
                <el-form-item prop="code">
                  <el-input v-model="infoForm.code" placeholder="请输入验证码" maxlength="4"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="padding-left:10px">
                <el-form-item>
                  <el-button type="primary" style="width: 100%;font-size: 16px;" :disabled="verCodeButtonStatus" @click="getVercode()">{{verCodeButtonName}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-button type="primary" :icon="loadIcon" @click="submitInfoForm('infoForm')" style="width: 100%;margin-top: 0px;font-size: 16px;" :disabled="submitInfoFormButtonStatus">5.8元试听AI测开，学完做AI测试开发</el-button>
        </el-form>
      </el-card>
      <el-col :span="24" :md="12" :sm="24" class="image-card">
        <img :src="image5" alt="Image 5" />
      </el-col>
      <el-col :span="24" :md="12" :sm="24" class="image-card">
        <img :src="image6" alt="Image 6" />
      </el-col>
      <el-col :span="24" :md="12" :sm="24" class="image-card">
        <img :src="image7" alt="Image 7" />
      </el-col>
      <el-card shadow="always" style="padding-top: 7px;">
        <div style="font-size: 13px;text-align: center;padding-bottom: 12px;color: red;">{{titleFonet}}</div>
        <el-form v-if="formStatus === false" :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
          <el-form-item label="请选择您的岗位:（仅一次机会）" prop="post">
            <el-radio-group :disabled="needButtonStatus" v-model="ruleForm.post" class="radio-group">
              <el-radio label=1>我是开发</el-radio>
              <el-radio label=2>我是测试</el-radio>
              <el-radio label=3>其他岗位</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="请选择您的需求:（仅一次机会）" prop="demand" style="margin-top: 20px;">
            <el-radio-group :disabled="needButtonStatus" v-model="ruleForm.demand" class="radio-group">
              <el-radio label=1>借鉴思路</el-radio>
              <el-radio label=2>学习测开</el-radio>
              <el-radio label=3>好奇看下</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button :type="needButtonType" @click="submitForm('ruleForm')" style="width: 100%;margin-top: 12px;font-size: 16px;" :disabled="needButtonStatus">{{needButtonName}}</el-button>
          </el-form-item>
        </el-form>
        <el-form v-if="formStatus === true" :model="infoForm" :rules="infoRules" ref="infoForm" label-position="top" class="infoFrom">
          <el-form-item label="请输入您的姓名" prop="name" style="margin-bottom: 0px;">
            <el-input v-model="infoForm.name" placeholder="请输入姓名，非真实姓名无效"></el-input>
          </el-form-item>
          <el-form-item label="请输入您的手机" prop="phone" style="margin-bottom: 10px;">
            <el-input v-model="infoForm.phone" placeholder="手机号将作为联系您唯一凭证" maxlength="11"></el-input>
            <el-row style="padding-top:8px;width: 100%;">
              <el-col :span="12">
                <el-form-item prop="code">
                  <el-input v-model="infoForm.code" placeholder="请输入验证码" maxlength="4"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="padding-left:10px">
                <el-form-item>
                  <el-button type="primary" style="width: 100%;font-size: 16px;" :disabled="verCodeButtonStatus" @click="getVercode()">{{verCodeButtonName}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-button type="primary" :icon="loadIcon" @click="submitInfoForm('infoForm')" style="width: 100%;margin-top: 0px;font-size: 16px;" :disabled="submitInfoFormButtonStatus">5.8元试听AI测开，坚决不做功能测试</el-button>
        </el-form>
      </el-card>
      <el-col :span="24" :md="12" :sm="24" class="image-card" style="padding-top: 5px;">
        <img :src="image8" alt="Image 8" />
      </el-col>
    </el-row>
    <el-dialog title="您可以选择支付方式" :visible.sync="payDialogVisible" :close-on-click-modal="false" width="80%" style="margin-top: 25%;">
      <el-radio-group v-model="payType" class="radio-group">
        <el-radio :label=0>微信支付</el-radio>
        <el-radio :label=1>支付宝</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <div style="font-size: 12px;text-align: center;padding-bottom: 0px;color: red;padding-top: 4px;">支付渠道由教程作者独立对接开发</div>
        <el-button type="primary" style="width: 100%;" @click="createuserpayurl()">确 定</el-button>
      </span>
    </el-dialog>
    <div style="font-size: 8px; text-align: center; padding: 1px; line-height: 1;">
      <img src="/static/logo.ico" alt="公司Logo" style="height: 2em; vertical-align: middle;">
      &copy; 2025 张家界市洋么科技有限公司 - 备案号：
      <a href="http://beian.miit.gov.cn" target="_blank">湘ICP备2024068691号</a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      image1: '../../static/image1.png',
      image2: '../../static/image2.png',
      image3: '../../static/image3.png',
      image4: '../../static/image4.png',
      image5: '../../static/image5.png',
      image6: '../../static/image6.png',
      image7: '../../static/image7.png',
      image8: '../../static/image8.png',
      ruleForm: {
        post: '',
        demand: ''
      },
      rules: {
        post: [
          { required: true, message: '您的岗位为必选', trigger: 'change' }
        ],
        demand: [
          { required: true, message: '您的需求为必选', trigger: 'change' }
        ]
      },
      infoRules: {
        name: [
          { required: true, message: ' ', trigger: 'blur' },
          { min: 2, max: 5, message: ' ', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: ' ', trigger: 'blur' },
          { min: 11, max: 11, message: ' ', trigger: 'blur' }
        ],
        code: [
          { required: true, message: ' ', trigger: 'blur' },
          { min: 4, max: 4, message: ' ', trigger: 'blur' }
        ]
      },
      needButtonName: '点击提交您的试听需求',
      needButtonStatus: false,
      needButtonType: 'primary',
      formStatus: true,
      infoForm: {
        name: '',
        phone: '',
        code: ''
      },
      // titleFonet: '提交需求便于作者针对性给您安排试听',
      titleFonet: '作者会联系您安排试听，5.8元为试听显卡算力费用',
      // 抖音上报ID
      dyClickId: this.$route.query['clickid'],
      // B站上报ID
      trackid: this.$route.query['track_id'],
      verCodeButtonName: '获取验证码',
      verCodeButtonStatus: false,
      timer: null,
      countdown: 30,
      submitInfoFormButtonStatus: false,
      loadIcon: '',
      payType: 0,
      payDialogVisible: false
    }
  },
  created () {
    if (localStorage.getItem('ft') === 'true') {
    // if (this.formStatus === true) {
      this.formStatus = true
      this.titleFonet = '非传统培训机构，购买试听享高质量内容。'
      return ''
    }
    if (localStorage.getItem('st') === 'true') {
      const storedTimestamp = localStorage.getItem('timestamp')
      if (storedTimestamp) {
        const storedDate = new Date(storedTimestamp)
        const today = new Date()
        const diffTime = today - storedDate
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        if (diffDays > 7) {
          this.needButtonStatus = false
          this.needButtonName = ''
          localStorage.removeItem('st')
          localStorage.removeItem('timestamp')
        } else {
          this.needButtonStatus = true
          this.needButtonName = '您暂时不符合试听要求,请7天后再试！'
          this.needButtonType = 'danger'
        }
      }
    }
  },
  mounted () {},
  methods: {
    getVercode () {
      if (this.verCodeButtonStatus) return

      if (this.infoForm.phone.length === 0 || this.infoForm.name.length === 0) {
        this.$message({
          message: '请填写您的姓名和手机号',
          type: 'error',
          customClass: 'myBox',
          center: true
        })
        return
      }

      // 立即改变按钮状态
      this.verCodeButtonStatus = true
      this.verCodeButtonName = `${this.countdown}秒后重试`

      // 启动定时器进行倒计时
      this.timer = setInterval(() => {
        this.countdown -= 1 // 倒计时减一
        this.verCodeButtonName = `${this.countdown}秒后重试` // 更新按钮文本

        if (this.countdown <= 0) {
          clearInterval(this.timer) // 清除计时器
          this.verCodeButtonName = '获取验证码' // 重置按钮文本
          this.verCodeButtonStatus = false // 恢复按钮状态为可点击
          this.countdown = 30 // 重置倒计时
        }
      }, 1000)

      // 发送验证码请求
      var getCodeFromData = new FormData()
      getCodeFromData.append('p_number', this.infoForm.phone)
      this.$axios.post('/api/ten/msg/sendvercode/', getCodeFromData).then(res => {
        if (res.data.status === 'success') {
          this.$message({
            message: '验证码已发送，请耐心等待一下',
            type: 'success',
            customClass: 'myBox',
            center: true
          })
        } else {
          // 如果发送失败，显示错误信息
          this.$message({
            message: '验证码发送失败，请稍后再试',
            type: 'error',
            customClass: 'myBox',
            center: true
          })
        }
      }).catch(() => {
        // 如果请求失败，显示错误信息
        this.$message({
          message: '验证码发送失败，请稍后再试',
          type: 'error',
          customClass: 'myBox',
          center: true
        })
      })
    },
    submitForm () {
      if (this.ruleForm.post === '' || this.ruleForm.demand === '') {
        this.$message({
          message: '请选择您的岗位或需求',
          type: 'error',
          customClass: 'myBox',
          center: true
        })
        return ''
      }
      if (this.ruleForm.post !== '2' || this.ruleForm.demand !== '2') {
        localStorage.setItem('st', 'true')
        const today = new Date()
        const yearMonthDay = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
        localStorage.setItem('timestamp', yearMonthDay)

        this.needButtonStatus = true
        this.needButtonName = '您暂时不符合试听要求,请7天后再试！'
        this.needButtonType = 'danger'
        return ''
      } else {
        this.formStatus = true
        localStorage.setItem('ft', 'true')
        this.titleFonet = '非传统培训机构，购买试听享高质量内容。'
      }
    },
    submitInfoForm () {
      this.loadIcon = 'el-icon-loading'
      this.submitInfoFormButtonStatus = true
      if (!/^[\u4e00-\u9fa5]{2,}$/.test(this.infoForm.name)) {
        this.$message({
          message: '请输入您的真实姓名',
          type: 'error',
          customClass: 'myBox',
          center: true
        })
        this.loadIcon = ''
        this.submitInfoFormButtonStatus = false
        return ''
      }

      const reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if (!reg.test(this.infoForm.phone) && this.infoForm.phone.length !== 11) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error',
          customClass: 'myBox',
          center: true
        })
        this.loadIcon = ''
        this.submitInfoFormButtonStatus = false
        return ''
      }

      if (this.infoForm.code.length !== 4) {
        this.$message({
          message: '请输入正确的验证码',
          type: 'error',
          customClass: 'myBox',
          center: true
        })
        this.loadIcon = ''
        this.submitInfoFormButtonStatus = false
        return ''
      }
      var codeFromData = new FormData()
      codeFromData.append('p_number', this.infoForm.phone)
      codeFromData.append('v_code', this.infoForm.code)
      this.$axios.post('/api/ten/msg/vercode/', codeFromData).then((response) => {
        if (response.data.status === 'error') {
          this.$message({
            message: '验证码错误',
            type: 'error',
            customClass: 'myBox',
            center: true
          })
          this.loadIcon = ''
          this.submitInfoFormButtonStatus = false
          return false
        } else if (response.data.status === 'success') {
          setTimeout(() => {
            this.loadIcon = ''
            this.submitInfoFormButtonStatus = false
            this.verCodeButtonStatus = false
          }, 15000)
          this.payDialogVisible = true
        }
      }).catch(() => {
        return false
      })
    },
    createuserpayurl () {
      this.payDialogVisible = false
      var payFromData = new FormData()
      payFromData.append('name', this.infoForm.name)
      payFromData.append('phone', this.infoForm.phone)
      payFromData.append('dy_click_id', this.dyClickId)
      payFromData.append('payType', this.payType)
      payFromData.append('trackid', this.trackid)
      if (this.trackid !== 'undefined') {
        localStorage.setItem('bilibili', 1)
      } else {
        localStorage.setItem('bilibili', 0)
      }
      this.$axios.post('/api/wechat/payment/createuserpayurl/', payFromData).then((response) => {
        if (response.status !== 200) {
          this.$message({
            message: '系统异常,请稍后再试',
            type: 'error',
            customClass: 'myBox',
            center: true
          })
          return ''
        }
        if (response.data.code !== 0) {
          this.$message({
            message: response.data.error,
            type: 'error',
            customClass: 'myBox',
            center: true
          })
          return ''
        }
        if (response.data.code === 0) {
          localStorage.setItem('outTradeNo', response.data.out_trade_no)
          localStorage.setItem('payType', this.payType)
          // 微信需要手动拼接返回URL
          if (this.payType === 0) {
            window.location.href = response.data.url + '&redirect_url=https://pay.yangmeai.com/payresult?No=1'
          } else {
            window.location.href = response.data.url
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.image-gallery {
  padding: 1px; /* 根据需要调整 */
  text-align: left;
}

.image-card {
  padding: 0; /* 去除内边距 */
  margin: 0; /* 去除外边距 */
}

.image-card img {
  max-width: 100%;
  height: auto; /* 保持图片原始比例 */
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.radio-group .el-radio {
  flex-grow: 1;
  margin-right: 0px;
  padding-left: 10px;
}

.el-form-item__error {
  display: none;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding-bottom: 0px;
}

/deep/ .el-form-item__label {
  padding-bottom: 0px;
}
</style>
<style lang="less">
.myBox {
  min-width: 70% !important;
}

.el-radio__label {
  padding-left: 3.8px;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding-bottom: 0px;
}

/deep/ .el-form-item__label {
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue